import Config from "./config";

let internalState = {
    countries: [],
    locations: []
};

let State = {
    timer: null,
    data: new Proxy(internalState, {
        set: (target, prop, value) => {
            if (Config.isDevEnvironment) {
                if (target.hasOwnProperty(prop)) {
                    console.log(`Setting existing property ${prop} to ${value}`);
                } else {
                    console.log(`Setting non-existent property '${prop}', initial value: ${value}`);
                }
            }
            target[prop] = value;
            if (State.timer) clearTimeout(State.timer);
            State.timer = setTimeout(() => {
                State.notifySubscribers("changed", prop, value, internalState);
            }, 100);

            return true;
        }
    }),
    subscribers: {},
    init() {

    },
    get(prop) {
        if (this.data.hasOwnProperty(prop)) return this.data[prop];
        else return undefined;
    },
    set(prop, value) {
        this.data[prop] = value;
    },
    subscribe(subscriber, handler) {
        if (!subscriber || !handler) return;
        console.log(`Subscribing ${subscriber} to state changes`);
        this.subscribers[subscriber] = handler;
    },
    unsubscribe(subscriber) {
        if (!subscriber) return;
        console.log(`Unsubscribing ${subscriber} from state changes`);
        if (this.subscribers.hasOwnProperty(subscriber)) {
            delete this.subscribers[subscriber];
        }
    },
    notifySubscribers(message, prop, value, internalState) {
        if (!message) return;
        for (let k in this.subscribers) {
            if (this.subscribers.hasOwnProperty(k) && this.subscribers[k]) {
                this.subscribers[k](message, prop, value, internalState);
            }
        }
    }
};
export default State;